import privateInstance from "../privateClient";
import { GlobalSettingsQueryType, PersonalSettingsQueryType } from "./types";

export const settingsApi = {
  getGlobalSettings: async () => {
    try {
      const response =
        await privateInstance.get<GlobalSettingsQueryType["Data"]>(
          "/app-settings",
        );

      return response.data;
    } catch (err) {
      return null;
    }
  },

  getPersonalSettings: async () => {
    try {
      const response = await privateInstance.get<
        PersonalSettingsQueryType["Data"]
      >("/user-settings", {
        params: {
          OverridableOnly: true,
        },
      });

      return response.data;
    } catch (err) {
      return null;
    }
  },
};
